import React, { Fragment } from "react";
import { bool, func, shape, string } from "prop-types";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import Icon from "../../../../components/Icon";
import defaultClasses from "@magento/venia-ui/lib/components/Navigation/navHeader.css";
import myClasses from "./navHeader.module.scss";
import { useNavigationHeader } from "@magento/peregrine/lib/talons/Navigation/useNavigationHeader";
import Trigger from "../Trigger";
const NavHeader = props => {
  const {
    isTopLevel,
    onBack,
    view
  } = props;
  const talonProps = useNavigationHeader({
    isTopLevel,
    onBack,
    view
  });
  const {
    handleBack,
    isTopLevelMenu
  } = talonProps;
  const classes = mergeClasses(myClasses, defaultClasses, props.classes);
  const backIcon = isTopLevelMenu ? "icon-close" : "icon-arrow-left";
  return /*#__PURE__*/React.createElement(Trigger, {
    key: "backButton",
    action: handleBack
  }, /*#__PURE__*/React.createElement(Icon, {
    name: backIcon,
    header: true,
    className: classes.iconStyle
  }));
};
export default NavHeader;
NavHeader.propTypes = {
  classes: shape({
    buttonBack: string,
    backRow: string,
    iconStyle: string
  }),
  isTopLevel: bool,
  onBack: func.isRequired,
  view: string.isRequired
};